var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-6 mt-1 mr-2"},[_c('InlineTaskKanbanListWrapper',{ref:"taskWrapper",attrs:{"message":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }